<template>
    <div class="form-group">
        <label for="namesearch"
            class="d-none">Suche nach Objektname</label>
        <div class="form-flex-area">
            <div class="input-group-btn">
                <input id="nameearch"
                    class="form-control"
                    type="text"
                    v-model="searchText"
                    placeholder="Suche nach Objektname"
                    @input="filterNames"
                    autocomplete="off"
                    @keydown.down="onArrowDown"
                    @keydown.up="onArrowUp"
                    @keydown.enter="onEnter"
                    @blur="closeSuggestions()"
                    :disabled="nameSelected" />
                <li aria-hidden="true"
                    v-if="module == 'index'"
                    class="fa-sharp fa-light fa-home"></li>
                <!-- Hier wird der Löschen-Button hinzugefügt -->
                <div class="input-group-append"
                    v-if="nameSelected">
                    <button class="btn btn-outline-secondary"
                        type="button"
                        @click="clearSelection">
                        Löschen
                    </button>
                </div>
                <i v-if="!nameSelected"
                    class="fa-sharp fa-light fa-search"></i>
            </div>


            <ul v-if="showSuggestions"
                class="autocomplete-items">
                <li v-for="(suggestion, index) in suggestions"
                    :key="index"
                    @click="selectSuggestion(suggestion)"
                    @mouseenter="onMouseEnter(index)"
                    class="autocomplete-item"
                    :class="{ 'autocomplete-active': index === selectedSuggestion }">
                    {{ suggestion }}
                </li>
            </ul>
        </div>


    </div>
</template>

<script>
    export default {
    	voVueComponent: 'namesearch',
    	props: {
    		names: Array, // Das Array der Straßennamen von der Elternkomponente übergeben
    		module: String,
    	},
    	data() {
    		return {
    			searchText: "",
    			suggestions: [],
    			selectedSuggestion: -1,
    			nameSelected: false,
    		};
    	},

    	mounted: function() {
    		var that = this;
    		$(document).click(function(e) {
    			//console.log('e.target.id::' + e.target.id);
    			//console.log("$(e.target).attr('class ')::" + $(e.target).attr('class'));
    			if ((!$(e.target).attr('class') || !$(e.target).attr('class').includes("autocomplete-item")) && e.target.id != "nameearch") {
    				//console.log('clearing suggestions...');
    				that.suggestions = [];
    				if (!that.nameSelected) {
    					that.searchText = "";
    					//that.$parent.setName();
    				}
    			}
    		});
    	},

    	computed: {
    		showSuggestions() {
    			return this.suggestions.length > 0;
    		},
    	},
    	methods: {
    		closeSuggestions() {
    				setTimeout(() => {
    					const myInputElement = document.getElementById('namesearch');
    					if (myInputElement) {
    						myInputElement.value = '';
    					}
    					this.suggestions = [];
    				}, "1000");
    			},
    			sortSuggestions() {
    				this.suggestions.sort((a, b) => a.localeCompare(b));
    			},
    			filterNames() {
    				const val = this.searchText.toUpperCase();
    				this.suggestions = this.names.filter((name) =>
    					name.toUpperCase().includes(val)
    				);

    				// Sortiere die Vorschläge alphabetisch
    				this.sortSuggestions();

    				this.selectedSuggestion = -1;
    			},
    			selectSuggestion(suggestion) {
    				this.searchText = suggestion;
    				this.suggestions = [];
    				var ids;
    				const suffix = VOFFICE.token.substr(VOFFICE.token.length - 12);
    				const storedData = JSON.parse(localStorage.getItem('uniqueNamesData_' + suffix));
    				//console.log("Ausgewählte Straße:", this.searchText);
    				if (storedData) {

    					if (storedData.data.includes(this.searchText)) {
    						// Die Straße ist vorhanden, daher können wir die IDs lesen
    						const nameIds = storedData.ids[this.searchText];
    						//console.log('this.forIndex::' + this.forIndex);
    						//console.log("nameIds.length::" + nameIds.length);
    						if ((this.module == 'index' || this.module == 'navbar') && nameIds.length == 1) {
    							window.location.href = './' + storedData.path[this.searchText];
    						} else {
    							this.$parent.lastUrl = undefined;
    							this.$parent.setName(nameIds);
    							this.nameSelected = true;
    						}
    						//console.log(`IDs für ${this.searchText}:`, nameIds);
    					}


    				}

    			},
    			clearSelection() {
    				// Diese Methode wird aufgerufen, um die ausgewählte Straße zu löschen
    				this.searchText = "";
    				this.nameSelected = false;
    				this.$parent.lastUrl = undefined;
    				this.$parent.setName();
    			},
    			onArrowDown() {
    				if (this.selectedSuggestion < this.suggestions.length - 1) {
    					this.selectedSuggestion++;
    				}
    			},
    			onArrowUp() {
    				if (this.selectedSuggestion > -1) {
    					this.selectedSuggestion--;
    				}
    			},
    			onEnter() {
    				if (this.selectedSuggestion !== -1) {
    					this.searchText = this.suggestions[this.selectedSuggestion];
    					this.suggestions = [];
    				}
    			},
    			onMouseEnter(index) {
    				this.selectedSuggestion = index;
    			},
    	},

    };
</script>

<style>
    .autocomplete-items {
    	list-style-type: none;
    	padding: 0;
    	margin: 0;
    	border: 1px solid #ccc;
    	display: block;
    }

    .autocomplete-items li {
    	padding: 8px;
    	cursor: pointer;
    }

    .autocomplete-items li:hover {
    	background-color: #00427A;
    }

    .autocomplete-active {
    	background-color: #00427A;
    	color: white;
    }
</style>